import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const userTerminateAccountDetailsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.userTerminateAccountDetails,
    queryFn: () => API.user.getUserTerminateAccountDetails(),
  });
